module.exports = __webpack_public_path__ + "img/logo-sm-dark.aff9f6db.png";